import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  effect,
  inject,
  input,
  OnDestroy,
  output,
  Type,
  ViewContainerRef
} from '@angular/core';
import { NotificationDto } from '../../models/notifications-grouped.model';
import {
  NOTIFICATION_ITEM_REGISTRY,
  NotificationItemBase,
  NotificationItemRegistry
} from '../../tokens/notification-item-registry.token';

@Component({
  selector: 'ca-notification-item-renderer',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class NotificationItemRendererComponent implements OnDestroy {
  notification = input.required<NotificationDto>();
  typeCode = input.required<string>();
  markAsRead = output<number>();
  delete = output<number>();

  private componentRef?: ComponentRef<NotificationItemBase>;
  private readonly vcr = inject(ViewContainerRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly registry = inject<NotificationItemRegistry>(NOTIFICATION_ITEM_REGISTRY);

  constructor() {
    effect(() => {
      this.renderComponent(this.typeCode(), this.notification());
    });
  }

  private renderComponent(typeCode: string, notification: NotificationDto): void {
    this.vcr.clear();

    const ComponentType = this.registry.get(typeCode) as Type<NotificationItemBase> | undefined;
    if (!ComponentType) {
      return;
    }

    this.componentRef = this.vcr.createComponent(ComponentType);
    this.componentRef.setInput('notification', notification);

    const instance = this.componentRef.instance;
    instance.markAsRead.subscribe((id: number) => this.markAsRead.emit(id));
    instance.delete.subscribe((id: number) => this.delete.emit(id));

    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.vcr.clear();
  }
}
